import React from 'react';
import { useDispatch } from 'react-redux';
import { Snackbar, Box } from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { useSnackBar } from '../../stores/ui/ui.hooks';
import { setSnackBar } from '../../stores/ui/ui-action';
import Spacing from '../../components/portico/spacing/spacing';
import useSnackBarStyles from './snack-bar.styles';

interface SnackBarProps {
    alertType?: string;
}

const Alert = (props: AlertProps) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const SnackBar: React.FC<SnackBarProps> = ({ alertType }) => {
    const dispatch = useDispatch();
    const snackBar = useSnackBar();
    const classes = useSnackBarStyles();

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') return;

        dispatch(setSnackBar({ show: false }));

        //handle consecutive Snackbars for send to external system event
        if (snackBar.consecutiveMessage) {
            dispatch(
                setSnackBar({
                    show: true,
                    message: snackBar.consecutiveMessage,
                    messageType: snackBar.consecutiveMessageType,
                    autoHideDuration: "disable",
                })
            );
        }
    };

    return (
        <Snackbar 
            anchorOrigin={snackBar.anchorOrigin} 
            open={snackBar.show} 
            autoHideDuration={
                snackBar.autoHideDuration === "disable" 
                ? null 
                : (snackBar.autoHideDuration ?? 6000)
            } 
            onClose={handleClose}>
            <Alert data-testid={'alert'} severity={snackBar.messageType} onClose={handleClose} iconMapping={{ success: <CheckCircleIcon />, info: <Box display="flex" alignItems="center" ><HourglassEmptyIcon /></Box> }} className={snackBar.messageType === 'success' ? classes.success : snackBar.messageType === 'info' ? classes.info : classes.error}>
                {snackBar.message}
                <Spacing variable="spacing-base" />
                {snackBar.description}
            </Alert>
        </Snackbar>
    )
}
